/**
 * Notifications module
 */

export function showNotification(message, type = 'info') {
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.innerHTML = `
        <div class="notification-content">
            <span class="notification-message">${message}</span>
            <button class="notification-close" onclick="closeNotification(this.parentElement.parentElement)">&times;</button>
        </div>
    `;

    // One fixed stack (bottom-right) so several toasts never overlap; styled
    // by the "showNotification() TOASTS" block in main.css.
    let stack = document.getElementById('notificationStack');
    if (!stack) {
        stack = document.createElement('div');
        stack.id = 'notificationStack';
        document.body.appendChild(stack);
    }
    stack.appendChild(notification);
    setTimeout(() => notification.classList.add('show'), 10);
    setTimeout(() => closeNotification(notification), 5000);
}

export function closeNotification(notification) {
    if (!notification) return;
    notification.classList.remove('show');
    setTimeout(() => {
        if (notification.parentNode) {
            notification.parentNode.removeChild(notification);
        }
    }, 300);
}

// Make functions available globally
window.showNotification = showNotification;
window.closeNotification = closeNotification;
